import styled from 'styled-components';

export const NotFoundStyle = styled.div`
  text-align: center;
`;

export const NotFoundImageWrapper = styled.div`
  margin-bottom: 38px;
  display: grid;
  justify-items: center;
`;

export const NotFoundText = styled.span`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.palette.darkGray};
`;
